import { render, staticRenderFns } from "./RelatedMedia.vue?vue&type=template&id=6c3edd38&"
import script from "./RelatedMedia.vue?vue&type=script&lang=js&"
export * from "./RelatedMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports